import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";
import {
  setQuickLinks,
  setReportsLinks,
  setHelpLinks,
  setSupportLinks,
  setCurrentMenu,
  setNavData,
} from "../store/slices/common/sidebarSlice";

const Navdata = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    
    // Get state from Redux
    const { quickLinks, reportsLinks, helpLinks, supportLinks, currentMenu } = useSelector(
        (state: RootState) => state.sidebarState
    );

    //state data
    const [isModules, setIsModules] = useState(currentMenu === 'modules');
    const [isQuickLinks, setIsQuickLinks] = useState(currentMenu === 'quicklinks');
    const [isReports, setIsReports] = useState(currentMenu === 'reports');
    const [isHelp, setIsHelp] = useState(currentMenu === 'help');
    const [isSupport, setIsSupport] = useState(currentMenu === 'support');

    const [isCurrentState, setIsCurrentState] = useState(currentMenu);

    // Update local state when Redux state changes
    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        setIsModules(currentMenu === 'modules');
        setIsQuickLinks(currentMenu === 'quicklinks');
        setIsReports(currentMenu === 'reports');
        setIsHelp(currentMenu === 'help');
        setIsSupport(currentMenu === 'support');
        setIsCurrentState(currentMenu);
    }, [currentMenu]);

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");

                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    const handleMenuClick = (menuType: string) => (e: any) => {
        e.preventDefault();
        // Only set the menu if it's not already active - this prevents toggling off
        if (currentMenu !== menuType.toLowerCase()) {
            dispatch(setCurrentMenu(menuType.toLowerCase()));
            setIsCurrentState(menuType.toLowerCase());
        }
        updateIconSidebar(e);
    };

    const menuItems: any = [
        {
            id: "modules",
            label: "Modules",
            icon: "bx bxs-dashboard",
            link: "#",
            stateVariables: isModules,
            isHeader: true,
            click: handleMenuClick('modules'),
            subItems: [
                {
                    id: "Products",
                    label: "Products",
                    link: "/products",
                    parentId: "modules",
                },
                {
                    id: "Orders",
                    label: "Orders",
                    link: "/orders",
                    parentId: "modules",
                },
                {
                    id: "Accounts",
                    label: "Accounts",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Contacts",
                    label: "Contacts",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Activity",
                    label: "Activity",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Reports",
                    label: "Reports",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Price",
                    label: "Price",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Product Lines",
                    label: "Product Lines",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Stocktake",
                    label: "Stocktake",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Campaigns",
                    label: "Campaigns",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Location",
                    label: "Location",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Service",
                    label: "Service",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Quote",
                    label: "Quote",
                    link: "#",
                    parentId: "modules",
                },
                {
                    id: "Bin Location",
                    label: "Bin Location",
                    link: "#",
                    parentId: "modules",
                },
            ],
        },
        {
            id: "quicklinks",
            label: "Quick Links",
            icon: "bx bx-link",
            link: "#",
            isHeader: true,
            stateVariables: isQuickLinks,
            click: handleMenuClick('quicklinks'),
            subItems: quickLinks,
        },
        {
            id: "reports",
            label: "Reports",
            icon: "bx bx-bar-chart-alt-2",
            link: "#",
            isHeader: true,
            stateVariables: isReports,
            click: handleMenuClick('reports'),
            subItems: reportsLinks,
        },
        {
            id: "help",
            label: "Help",
            icon: "bx bx-help-circle",
            link: "#",
            isHeader: true,
            stateVariables: isHelp,
            click: handleMenuClick('help'),
            subItems: helpLinks,
        },
        {
            id: "support",
            label: "Support",
            icon: "bx bx-support",
            link: "#",
            isHeader: true,
            stateVariables: isSupport,
            click: handleMenuClick('support'),
            subItems: supportLinks,
        },
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;